import React, { useState } from "react"
import { Button } from "react-bootstrap"

import PendingFieldPermissionChangesModal from "@/onboarding/features/bidding/components/PendingFieldPermissionChangesModal"
import {
  FieldSettingWithCurrentState,
  PendingFieldPermissionChange,
  PermissionFlag,
  TourFieldPermissions,
} from "@/onboarding/features/bidding/types"

type Props = {
  rows: FieldSettingWithCurrentState[]
  tours: TourFieldPermissions[]
}

const pendingFieldPermissionChanges = (
  rows: FieldSettingWithCurrentState[]
): PendingFieldPermissionChange[] =>
  rows.flatMap((row) =>
    Object.values(PermissionFlag).flatMap((permissionFlag) => {
      const pickedPermissionValue = row.pickedSetting[permissionFlag]

      if (pickedPermissionValue === undefined) {
        return []
      }

      return [{ fieldName: row.name, permissionFlag, pickedPermissionValue }]
    })
  )

const ReviewChanges = ({ rows, tours }: Props): JSX.Element => {
  const [show, setShow] = useState(false)
  const changes = pendingFieldPermissionChanges(rows)

  return (
    <div>
      <Button
        variant="outline-primary"
        disabled={changes.length === 0 || tours.length === 0}
        onClick={() => setShow(true)}
      >
        Review changes
      </Button>
      <PendingFieldPermissionChangesModal
        show={show}
        onHide={() => setShow(false)}
        changes={changes}
        tours={tours}
      />
    </div>
  )
}

export default ReviewChanges
